import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowUpRight, FiSun, FiMoon } from "react-icons/fi";
import { NAV } from "../../config/site";
import { LANGS } from "../../i18n";
import { useTheme } from "../../hooks/useTheme";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const { theme, toggle } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // close mobile drawer on navigation
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // lock body scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className={`nav${scrolled ? " scrolled" : ""}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo" aria-label={t("brand.full")}>
            <img src="/img/logo.png" alt={t("brand.full")} />
            <span className="wm">
              <b>D</b>EMA<b>R</b>
              <small>{t("brand.tagline")}</small>
            </span>
          </Link>

          <nav className="nav-links">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              >
                {t(`nav.${item.key}`)}
              </NavLink>
            ))}
          </nav>

          <div className="nav-right">
            <button className="theme-btn" onClick={toggle} aria-label="Tema" title={theme === "light" ? "Koyu tema" : "Açık tema"}>
              {theme === "light" ? <FiMoon /> : <FiSun />}
            </button>
            <LanguageSwitcher />
            <Link to="/iletisim" className="btn sm nav-cta">
              {t("nav.cta")} <FiArrowUpRight className="arrow" />
            </Link>
            <button
              className={`nav-burger${open ? " open" : ""}`}
              onClick={() => setOpen((v) => !v)}
              aria-label="Menu"
              aria-expanded={open}
            >
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>

      <div className={`nav-mobile${open ? " open" : ""}`}>
        <div className="nav-mobile-inner">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {t(`nav.${item.key}`)} <FiArrowUpRight />
            </NavLink>
          ))}
          <div className="m-langs">
            {LANGS.map((l) => (
              <button
                key={l.code}
                className={`m-lang${l.code === i18n.resolvedLanguage ? " active" : ""}`}
                onClick={() => i18n.changeLanguage(l.code)}
              >
                {l.label}
              </button>
            ))}
            <button className="m-lang" onClick={toggle} aria-label="Tema" style={{ flex: "0 0 auto", width: 48 }}>
              {theme === "light" ? <FiMoon /> : <FiSun />}
            </button>
          </div>
          <Link to="/iletisim" className="btn m-cta">{t("nav.cta")} <FiArrowUpRight className="arrow" /></Link>
        </div>
      </div>
    </>
  );
}
